import React, { useState, useEffect } from 'react';
import './PreferencesModal.css';

const PreferencesModal = ({
  cyclicEnabled,
  setCyclicEnabled,
  autoAssignEnabled,
  setAutoAssignEnabled,
  onApply,
  onCancel,
  onReset
}) => {
  const [tempCyclicEnabled, setTempCyclicEnabled] = useState(cyclicEnabled);
  const [tempAutoAssignEnabled, setTempAutoAssignEnabled] = useState(autoAssignEnabled);

  // Kiedy modal się pojawia, ustawiamy tymczasowe checkboxy zgodnie z obecnymi preferencjami
  useEffect(() => {
    setTempCyclicEnabled(cyclicEnabled);
    setTempAutoAssignEnabled(autoAssignEnabled);
  }, [cyclicEnabled, autoAssignEnabled]);

  const handleApply = () => {
    onApply({
      cyclicEnabled: tempCyclicEnabled,
      autoAssignEnabled: tempAutoAssignEnabled
    });
  };

  return (
    <div className="preferences-modal">
      <div className="preferences-content">
        <h3>Preferencje</h3>

        <label>
          <input
            type="checkbox"
            checked={tempCyclicEnabled}
            onChange={(e) => setTempCyclicEnabled(e.target.checked)}
          />
          Zaznaczanie Cyklu
          <div style={{ fontSize: '0.85rem', color: '#555', marginLeft: '1.5rem' }}>
            Zarezerwuj dni powtarzające się co tydzień (np. każdy poniedziałek).
          </div>
          <div style={{ fontSize: '0.85rem', color: '#555', marginLeft: '1.5rem' }}>
            Zazacz dwie daty - początek i koniec.
          </div>
        </label>

        <label>
          <input
            type="checkbox"
            checked={tempAutoAssignEnabled}
            onChange={(e) => setTempAutoAssignEnabled(e.target.checked)}
          />
          Automatyczne przypisywanie miejsca (ukryj mapę)
          <div style={{ fontSize: '0.85rem', color: '#555', marginLeft: '1.5rem' }}>
            System sam wybierze dostępne miejsce — nie trzeba zaznaczać na mapie.
          </div>
        </label>

        <div className="preferences-buttons">
          <button onClick={onCancel}>Anuluj</button>
          <button onClick={handleApply}>Zastosuj</button>
          <button onClick={onReset}>Reset Preferencji</button>
        </div>
      </div>
    </div>
  );
};

export default PreferencesModal;
